const socket = new WebSocket("wss://webvwlive.finvu.in/consentapi");
export default socket;

export function onMessageHandler(event) {
  const data = JSON.parse(event.data);
  return data;
}